// extracted by mini-css-extract-plugin
module.exports = {"cancellation-offer":"CancellationOffer_cancellation-offer__29wCd","hand-gift":"CancellationOffer_hand-gift__2QYee","high-light-text":"CancellationOffer_high-light-text__3WyuM"};